import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import List from './list.vue'
import VerifyUploadLocation from './verifyUploadLocation.vue'

const basePath = '/v-admin/job-location/management'

export default {
  name: 'jobLocationManagement',
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    permission: 'PERM_ADMIN_COMPANY_JOB_LOCATION_MANAGE',
    titleI18nKey: 'admin.company.jobLocationManagement.title',
    menu: {
      get label () {
        return i18n.t('admin.company.jobLocationManagement.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        permission: 'PERM_ADMIN_COMPANY_JOB_LOCATION_MANAGE',
        titleI18nKey: 'admin.company.jobLocationManagement.title'
      }
    },
    {
      path: `${basePath}/verify-upload`,
      component: VerifyUploadLocation,
      meta: {
        isNewPage: true,
        permission: 'PERM_ADMIN_COMPANY_JOB_LOCATION_MANAGE',
        titleI18nKey: 'admin.company.jobLocationManagement.label.uploadLocation'
      }
    }
  ]
}
